export const SignUpSideBanner = {
  IDV: {
    title: "Lystproof for Individual",
    points: [
      "Maintain verified employment data",
      "User privacy",
      "Faster verification processes",
      "Easy file sharing options",
      "Permissions to share files",
      "Integrate with payroll",
    ],
    imageUrl: "/images/signup-side-banner-VFR.svg",
  },
  ORG: {
    title: "Lystproof for organization",
    points: [
      "All work records in one place",
      "Internal and external file transfers",
      "Safe & secure data sharing",
      "Easy to access",
      "Hassle-free verification process",
      "Integrate with payroll",
    ],
    imageUrl: "/images/signup-side-banner-VFR.svg",
  },
  VFR: {
    title: "Lystproof for Commercial verifier",
    points: [
      "Lesser turnaround time",
      "Online file sharing",
      "Accurate employment history",
      "Data security",
      "Multi-company verification",
      "Integrate with payroll",
    ],
    imageUrl: "/images/signup-side-banner-VFR.svg",
  },
};
